module.exports = __webpack_public_path__ + "static/media/1005599.f24ffaba.png";